import { AfterViewInit, Component, ElementRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { TransportDetail, TransportDetailDefinition, TransportDetailLayout, TransportDetailLayoutFieldReference, TransportDetailMode } from '../../../../common/configuration/transport.configuration';
import { Transport } from '../../../../common/model/transport.model';

@Component({
  selector: 'app-transport-details',
  templateUrl: './transport-details.component.html',
  styleUrls: ['./transport-details.component.scss'],
  standalone: false
})
export class TransportDetailsComponent implements OnInit, AfterViewInit {

  TransportDetailDefinition = TransportDetailDefinition;

  formGroup: FormGroup;

  layout: TransportDetailLayout;

  transport: Transport;

  @Input('transport') set setTransport(value: Transport) {
    this.transport = value;
    this.patchValues();
  }

  @Input('layout') set setLayout(value: TransportDetailLayout) {
    console.log('layout definition is set', value);
    this.layout = new TransportDetailLayout(value);
    this.createFormGroup();
  }

  @Input() mode = TransportDetailMode.READONLY;

  @Input() disableAutoComplete: boolean = false;

  @Output() validState = new BehaviorSubject<boolean>(false);

  @Output() valueChange = new Subject<void>();

  valueSubscription: Subscription;

  private firstFocusableFieldReference: TransportDetailLayoutFieldReference = null;

  constructor(private ref: ElementRef) { }
  ngAfterViewInit(): void {
    this.setFocus();
  }

  ngOnInit(): void {
    this.patchValues();

  }

  createFormGroup() {

    console.log('creating form group from layout', this.layout);

    if (this.valueSubscription != null) {
      this.valueSubscription.unsubscribe();
      this.valueSubscription == null;
    }

    if (this.layout == null) {
      this.formGroup = null;
      return;
    }

    const formGroup = new FormGroup({});
    for (const sequence of this.layout.sequences) {
      for (const column of sequence.columns) {
        for (const row of column.rows) {
          for (const fieldReference of row.fields) {
            fieldReference.detail = this.getDetail(fieldReference.key);
            if (fieldReference.detail != null && fieldReference.detail.isEditable) {
              if (this.firstFocusableFieldReference == null) {
                this.firstFocusableFieldReference = fieldReference;
              }
              formGroup.addControl(fieldReference.identifier, this.createControl(fieldReference.detail, fieldReference));
            } else {
              console.warn('field reference is not editable', fieldReference);
            }
          }
        }
      }
    }

    this.valueSubscription = formGroup.valueChanges.subscribe(value => {

      console.log('details panel value changes', value);

      if (this.mode === TransportDetailMode.READONLY) {
        return;
      }

      if (this.transport != null) {
        for (const sequence of this.layout.sequences) {
          for (const column of sequence.columns) {
            for (const row of column.rows) {
              for (const fieldReference of row.fields) {
                console.log('checking field reference', fieldReference);
                if (fieldReference.detail != null && fieldReference.detail.attribute != null) {
                  console.log('found field reference');
                  if (fieldReference.detail.isEditable && !fieldReference.disabled) {
                    console.log('setting value for', fieldReference.detail.attribute, 'to', value[fieldReference.identifier]);
                    this.setValue(this.transport, fieldReference.detail.attribute.split('.'), value[fieldReference.identifier]);
                  }
                }
              }
            }
          }
        }
      }

      if (this.formGroup.valid !== this.validState.getValue()) {
        this.validState.next(this.formGroup.valid);
      }



      this.valueChange.next();

    });

    this.formGroup = formGroup;

    if (this.formGroup.valid !== this.validState.getValue()) {
      this.validState.next(this.formGroup.valid);
    }
  }

  private getDetail(identifier: string): TransportDetail {
    for (const group of TransportDetailDefinition) {
      for (const detail of group.details) {
        if (detail.identifier === identifier) {
          return detail;
        }
      }
    }
    console.warn('no detail definition available for identifier', identifier);
    return null;
  }

  private patchValues() {
    console.log('patching values', this.formGroup, this.transport, this.layout);
    if (this.formGroup != null && this.transport != null && this.layout != null) {
      let value: any = {};
      for (const sequence of this.layout.sequences) {
        for (const column of sequence.columns) {
          for (const row of column.rows) {
            for (const fieldReference of row.fields) {
              if (fieldReference.detail != null && fieldReference.detail.attribute != null) {
                value[fieldReference.identifier] = this.getValue(this.transport, fieldReference.detail.attribute.split('.'));
              }
            }
          }
        }
      }
      console.log('setting values', value);
      this.formGroup.patchValue(value);
    }
  }

  createControl(detail: TransportDetail, fieldReference: TransportDetailLayoutFieldReference): AbstractControl {
    let fc = new FormControl(null, []);
    let validators = new Array<ValidatorFn>();
    if (fieldReference.required) {
      validators.push(Validators.required);
    }
    fc.setValidators(validators);
    if (fieldReference.disabled) {
      console.log('disabling field', fieldReference.identifier);
      fc.disable();
    }
    return fc;
  }

  private getValue(obj: any, path: Array<string>): any {
    if (obj == null || obj == undefined) {
      return null;
    }
    if (path.length > 1) {
      const attribute = path.shift();
      return this.getValue(obj[attribute], path);
    } else {
      return obj[path[0]];
    }
  }

  private setValue(obj: any, path: Array<string>, value: any) {
    if (obj == null || obj == undefined) {
      return;
    }
    if (path.length > 1) {
      const attribute = path.shift();
      return this.setValue(obj[attribute], path, value);
    } else {
      obj[path[0]] = value;
    }
  }

  private setFocus() {
    if (this.firstFocusableFieldReference != null) {
      this.ref.nativeElement.querySelector('[name=' + this.firstFocusableFieldReference.key + ']')?.focus();
    }
  }

  handleValueChange() {
    this.valueChange.next();
  }

}
